var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"text"},[_vm._v("500エラーが発生しました。")]),_c('a',{attrs:{"href":_vm.topPage}},[_vm._v("トップページへ戻る")])])}
var staticRenderFns = []

export { render, staticRenderFns }